// ゲストモード (Supabase の匿名認証) の判定・文言をまとめる。
//
// 「登録せずに試す」は Supabase の signInAnonymously() で匿名ユーザーを作り、
// 通常のログイン済みユーザーと同じ経路でアプリを動かす方式。RLS もそのまま効くので
// アプリ側に「ゲスト用の分岐」を増やさなくてよい。
//
// 有効にするには Supabase Dashboard → Authentication → Sign In / Providers →
// 「Allow anonymous sign-ins」を ON にする必要がある。OFF のときは API が
// `anonymous_provider_disabled` を返すので、UI はそれを検知して通常のサインアップへ誘導する。
//
// 匿名ユーザーは 30 日で削除される (supabase/migrations/20260918120200_cleanup_anonymous_users.sql)。
// データを残すにはサインアップ画面でメール登録 (updateUser) するとその場でアカウントに昇格する。

/** 匿名ユーザーかどうか。supabase-js の User.is_anonymous を見る */
export function isGuestUser(user: { is_anonymous?: boolean | null } | null | undefined): boolean {
  return user?.is_anonymous === true;
}

/** Supabase 側で匿名ログインが無効なときのエラーかどうか */
export function isAnonymousSignInDisabledError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const e = error as { code?: unknown; message?: unknown; status?: unknown };
  if (e.code === "anonymous_provider_disabled") return true;
  return typeof e.message === "string" && /anonymous sign-ins are disabled/i.test(e.message);
}

/** ゲスト開始ボタンが失敗したときにユーザーへ出す文言 */
export function guestStartErrorMessage(error: unknown): string {
  if (isAnonymousSignInDisabledError(error)) {
    return "ゲスト利用はいま準備中です。無料登録からお試しください。";
  }
  return "ゲストとして開始できませんでした。時間をおいて再度お試しください。";
}

/** ゲストのデータが消えるまでの日数 (マイグレーションの cron と揃える) */
export const GUEST_RETENTION_DAYS = 30;

/** ゲストバナーの文言 */
export const GUEST_BANNER_TEXT = `ゲストとして利用中です。データは ${GUEST_RETENTION_DAYS} 日で消えます。残すにはアカウントを登録してください。`;

/** サインアップ画面でゲストを昇格させるときの見出し */
export const GUEST_CONVERT_HEADING = "アカウントを登録してデータを残す";
